import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Image from 'next/image';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Chip,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from 'styles/pages/segments.module.scss';
import { actionGetModelsWith4x4, actionGetModelsWithHybridElectric } from 'store/actions';
import getSegmentsModels from 'lib/getSegmentsModels';
import getBrandsModels from 'lib/getBrandsModels';
import getPosts from 'lib/getPosts';
import Link from 'components/link';
import { urlWriter, randIndex } from 'tools/functions';
import Breadcrumb from 'components/breadcrumb';

const WidgetNav = dynamic(() => import('../../components/widgetNav'), {
    ssr: false,
});

const WidgetLaunches = dynamic(() => import('../../components/widgetLaunches'), {
    ssr: false,
});

const WidgetPromo = dynamic(() => import('../../components/widgetPromotion'), {
    ssr: false,
});

const Segments = (props) => {
    const {
        segments,
        brands,
        dataGetModelsWith4x4,
        errorGetModelsWith4x4,
        dataGetModelsWithHybridElectric,
        errorGetModelsWithHybridElectric,
    } = props;
    const [allSegments, setAllSegments] = useState(segments);

    useEffect(() => {
        props.actionGetModelsWith4x4();
        props.actionGetModelsWithHybridElectric();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dataGetModelsWith4x4) {
            const seg4x4 = {
                segment: '4x4',
                models: dataGetModelsWith4x4,
            };
            setAllSegments((all) => [...all, seg4x4]);
        }
    }, [dataGetModelsWith4x4, errorGetModelsWith4x4]);

    useEffect(() => {
        if (dataGetModelsWithHybridElectric) {
            const segHE = {
                segment: 'Voiture verte',
                models: dataGetModelsWithHybridElectric,
            };
            setAllSegments((all) => [...all, segHE]);
        }
    }, [dataGetModelsWithHybridElectric, errorGetModelsWithHybridElectric]);
    return (
        <div>
            <Head>
                <title>
                    Tous segments et types voiture au Maroc | prix, comparateur automobile
                    segments automobile au Maroc |
                </title>
                <meta
                    name="description"
                    content="Toutes les voitures neuves, tous segments et types voitures au Maroc.  "
                />
                <meta property="og:type" content="siteweb" />
                <meta
                    property="og:title"
                    content="Tous segments et types voiture au Maroc"
                />
                <meta
                    property="og:image"
                    content={`${process.env.NEXT_PUBLIC_API_HOST}/images/og/segments.png`}
                />
                <meta
                    property="og:url"
                    content={`${process.env.NEXT_PUBLIC_CLIENT_HOST}/segments-automobile`}
                />
                <link
                    rel="canonical"
                    href={`${process.env.NEXT_PUBLIC_CLIENT_HOST}/segments-automobile`}
                />
            </Head>
            <main className={styles.root}>
                <Breadcrumb
                    links={[
                        {
                            href: null,
                            text: 'segments voiture',
                        },
                    ]}
                />
                <div className="main-title">
                    <h1>Segments voiture au Maroc</h1>
                </div>
                <div className={styles.catList}>
                    {allSegments.map((segment) => (
                        <Card key={segment.segment} className={styles.cardRoot}>
                            <CardHeader title={<h2>{segment.segment}</h2>} />
                            <CardContent>
                                <Link
                                    href={`/segments-automobile/${urlWriter(
                                        segment.segment,
                                    )}`}
                                >
                                    <Image
                                        src={`${
                                            process.env.NEXT_PUBLIC_API_HOST
                                        }/images/models/${
                                            segment.models[
                                                randIndex(segment.models.length - 1, 1)
                                            ].images[0].filename
                                        }`}
                                        alt={segment.segment}
                                        width="240"
                                        height="160"
                                        priority
                                    />
                                </Link>
                            </CardContent>
                            <CardActions>
                                <Chip label={`${segment.models.length} modèles`} />
                                <Link
                                    href={`/segments-automobile/${urlWriter(
                                        segment.segment,
                                    )}`}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                    >
                                        {segment.segment}
                                    </Button>
                                </Link>
                            </CardActions>
                        </Card>
                    ))}
                </div>
                <WidgetNav brands={brands} />
                <WidgetLaunches data={brands} />
                <WidgetPromo data={brands} />
            </main>
        </div>
    );
};

Segments.propTypes = {
    segments: PropTypes.array.isRequired,
    brands: PropTypes.array.isRequired,
    dataGetModelsWith4x4: PropTypes.any,
    errorGetModelsWith4x4: PropTypes.any,
    actionGetModelsWith4x4: PropTypes.func.isRequired,
    dataGetModelsWithHybridElectric: PropTypes.any,
    errorGetModelsWithHybridElectric: PropTypes.any,
    actionGetModelsWithHybridElectric: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        dataGetModelsWith4x4: state.model.dataGetModelsWith4x4,
        errorGetModelsWith4x4: state.model.errorGetModelsWith4x4,
        dataGetModelsWithHybridElectric: state.model.dataGetModelsWithHybridElectric,
        errorGetModelsWithHybridElectric: state.model.errorGetModelsWithHybridElectric,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            actionGetModelsWith4x4,
            actionGetModelsWithHybridElectric,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Segments);

export async function getStaticProps() {
    let segments = await getSegmentsModels();
    segments = segments.data.segments;
    let posts = await getPosts();
    posts = posts.data.posts;
    let brands = await getBrandsModels();
    brands = brands.data.brands;
    return {
        props: {
            segments,
            posts,
            brands,
        },
    };
}
